import { useQuery } from "@tanstack/react-query";

import type { HistoryAttribute, PatientHistory } from "@/types/api/history";

import api from "./api";

const getPatientHistoryByAttribute = async (
  attribute: HistoryAttribute,
  patientId: number
): Promise<Array<PatientHistory>> => {
  const { data } = await api.get<Array<PatientHistory>>(
    `/patient-history/${patientId}/${attribute}`
  );
  return data;
};

export const useGetPatientHistoryByAttribute = (
  attribute: HistoryAttribute,
  patientId: number
) => {
  return useQuery({
    queryKey: ["patient-history-by-attribute", attribute, patientId],
    queryFn: () => getPatientHistoryByAttribute(attribute, patientId),
    enabled: !!attribute && !!patientId,
  });
};
